module.exports = new __parcel__URL__("ch4-wetland--cover.611a718d.jpeg").toString();